import React, { useState } from "react";
import { toast } from "sonner";
// ❌ axios not needed now
// import axios from 'axios';

// Put your Apps Script Web App URL here or in an env var
const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycby3ishSC7WguOfZtR9aycz3_82OM3j5YZ9lyco-El7Vl-8A8KIW3U0pOtlTSjaS7Hie3A/exec";

const CTAForm = () => {
  const [twitterHandle, setTwitterHandle] = useState("");
  const [question, setQuestion] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!twitterHandle.trim()) {
      toast.error("Twitter handle is required");
      return;
    }

    setIsSubmitting(true);

    try {
      // Fire-and-forget call to Google Apps Script
      await fetch(
        "https://script.google.com/macros/s/AKfycby1I0oT-JSxytRJOtVEakChlQ0RWG-m-hkdD12FuviIvNdh5KYe0DAK2fBhDSlLJOtp/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `USERNAME=${encodeURIComponent(
            twitterHandle
          )}&QUESTION=${encodeURIComponent(question)}`,
        }
      );

      // Since no-cors hides the response, just assume success if no error thrown
      toast.success("You are on the list! 🚀");
      setTwitterHandle("");
      setQuestion("");
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="cta-section">
      <div className="cta-container">
        <div className="cta-header">
          <h2 className="display-large cta-title">
            Q&gt; What's your question?
          </h2>
          <p className="body-medium cta-subtitle">
            Type the one question you want the world to trade on.
          </p>
        </div>

        <form className="cta-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="twitter" className="form-label body-medium">
              <span className="label-icon">@</span> Your Twitter Handle:{" "}
              <span className="required">*</span>
            </label>
            <input
              type="text"
              id="twitter"
              className="form-input"
              placeholder="username"
              value={twitterHandle}
              onChange={(e) => setTwitterHandle(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="question" className="form-label body-medium">
              <span className="label-icon">?</span> Suggest a Market:
            </label>
            <textarea
              id="question"
              className="form-textarea"
              placeholder="What question would you like to see traded?"
              rows="4"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="btn-primary submit-btn"
            disabled={isSubmitting}
          >
            <span>{isSubmitting ? "JOINING..." : "JOIN THE QUEST"}</span>
            <span>→</span>
          </button>

          <p className="form-microcopy body-small">
            Be among the first 1000 Wisdom Seekers. Get early access when nemeQ
            launches.
          </p>
        </form>

        <div className="cursor-line">
          <span className="cursor-text">_cursor blinking_</span>
          <span className="blinking-cursor">|</span>
          <span className="awaiting-text">awaiting your question...</span>
        </div>
      </div>
    </section>
  );
};

export default CTAForm;
